export default __webpack_public_path__ + "static/media/newyear6.297636c7.png";